import { useData } from '@hooks/useData';
import http from '@core/fetch';
import { components } from '@apiSchema';
import { IMacListItem, mapMacListDtos } from '@models/MacListItem';
import { PermissionLevelEnum, PermissionSection } from '@models/PermissionSection';

type MacsListResponse = components['schemas']['SnapMacListDtoListChainPermissionWrapper'];

export interface MacsListData {
    items: IMacListItem[];
    permissionLevel: PermissionLevelEnum;
    hasData: boolean;
}

const REQUEST_TYPE = 'macs list';
const EMPTY_MACS: MacsListData = { items: [], permissionLevel: PermissionLevelEnum.Full, hasData: true };

export async function getMacs(): Promise<MacsListData> {
    try {
        const response: MacsListResponse | null = await http.get(REQUEST_TYPE);

        return {
            items: mapMacListDtos(response?.data ?? []),
            permissionLevel: PermissionSection.getPermissionLevel(response?.permissionLevel),
            hasData: response?.hasData ?? true,
        };
    } catch (err) {
        console.error('Fetch error:', REQUEST_TYPE, err);
        return EMPTY_MACS;
    }
}

export function useMacs() {
    return useData(EMPTY_MACS, getMacs);
}
